import styled from "styled-components";
import {Select, Input} from "antd";

export const Wrapper = styled.div`
    background-color: transparent;
    flex-shrink: 0;
    display: flex;
    justify-content: ${props => (props.isOrdersPage ? "flex-start" : "flex-end")};
    position: relative;
    z-index: 1000;

    .ant-select-dropdown {
        z-index: 1050 !important;
    }

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    align-items: flex-end;
`;

export const SelectField = styled(Select)`
    width: 100%;
    min-width: 165px;
    max-width: 165px;
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        min-width: 165px;
        max-width: none;
        .ant-select-selector {
            min-width: 165px;
            font-size: 12px;
        }
    }
`;

export const Container = styled.div``;

export const RangePickerContainer = styled.div`
    margin-left: 8px;
    padding: 0;
    width: 165px;
    position: relative;
    z-index: 1000;

    .ant-picker {
        width: 165px;
    }

    .ant-picker-dropdown {
        z-index: 1050 !important;
    }

    .ant-picker-panel-container {
        z-index: 1050 !important;
    }

    @media (max-width: 768px) {
        width: 100%;
        .ant-picker {
            width: 100%;
        }
    }
`;

export const SpinnerContainer = styled.div`
    justify-items: center;
    width: 100%;
    margin-top: 16px;
    margin-left: 16px;
`;

export const InputContainer = styled(Input)`
    margin-left: 16px;
`;
